import { Suspense, lazy } from 'react';
import DesktopQuickLinks from './DesktopQuickLinks';
import DesktopAbout from './DesktopAbout';
import DesktopGiftCard from './DesktopGiftCard';
import BroadcastCarousel from '@/components/BroadcastCarousel';
import useHomeLayout from '@/lib/useHomeLayout';

const InstagramCarousel = lazy(() => import('@/components/InstagramCarousel'));

// Renders the App Home sections configured in the App Home Builder, on every screen size.
export default function AppHomeSections({ hero, broadcasts, onBroadcastClick }) {
  const { theme, sections } = useHomeLayout('app');

  const render = ({ type, settings: s }) => {
    switch (type) {
      case 'quick_links': return <DesktopQuickLinks s={s} theme={theme} />;
      case 'about': return <DesktopAbout s={s} theme={theme} />;
      case 'gift_card': return <DesktopGiftCard s={s} theme={theme} />;
      case 'news':
        if (!broadcasts?.length) return null;
        return (
          <section className="w-full mt-0 lg:mt-4 px-4 pt-1 lg:pt-3 lg:px-8" style={{ background: s.bg_color, fontFamily: theme.body_font }}>
            {s.title && <h2 className="text-2xl lg:text-4xl mb-1" style={{ color: s.text_color || theme.accent_color, fontFamily: theme.heading_font }}>{s.title}</h2>}
            {s.subtitle && <p className="text-sm mb-3" style={{ color: s.text_color || theme.primary_color }}>{s.subtitle}</p>}
            <BroadcastCarousel broadcasts={broadcasts} onBroadcastClick={onBroadcastClick} desktopCarousel />
          </section>
        );
      case 'instagram':
        return <Suspense fallback={<div className="h-64 bg-gray-100 animate-pulse" />}><InstagramCarousel title={s.title} subtitle={s.subtitle} textColor={s.text_color} /></Suspense>;
      default: return null;
    }
  };

  return <>{sections.filter((sec) => sec.visible !== false).map((sec) => <div key={sec.id}>{render(sec)}</div>)}</>;
}